import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {Property} from "../../../model/property";
import {formatDate} from "@angular/common";
import {User} from "../../../model/user";
import {AuthorityData} from "../../../model/authorityData";
import {SignaturePadComponent} from "../../signature-pad/signature-pad.component";
import {UserServiceService} from "../../../service/user-service.service";
import * as $ from 'jquery';
import {PlatformUtils} from "../../../utils/platform-utils";
import {PlatformProfile} from "../../../model/platformprofile";

/**
 * automatically generated authority with the opportunity to sign it.
 */
@Component({
  selector: 'app-authority-preview',
  templateUrl: './authority-preview.component.html',
  styleUrls: ['./authority-preview.component.css']
})

export class AuthorityPreviewComponent implements OnInit, AfterViewInit {
  mobile: boolean = false;
  errorMsg: string;
  interest: string = "init"

  properties: Array<Property>;
  authorityData: AuthorityData;
  user: User;
  currentMultiUserPlatform: PlatformProfile | undefined;
  @Output() authoritySigned: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @ViewChild(SignaturePadComponent) signaturePad: SignaturePadComponent;

  constructor(private userService: UserServiceService) {
    let obj = sessionStorage.getItem("user");
    if (obj){
      this.user = JSON.parse(obj);
    }

  }

  ngOnInit(): void {
    let retrievedObject = sessionStorage.getItem('new_order_properties');
    this.properties = JSON.parse(retrievedObject);
    this.currentMultiUserPlatform = PlatformUtils.getCurrentMultiUserPlatformProfileFromSession();

    if (window.screen.width <= 1000) {
      this.mobile = true;
    }
    if (!this.user) {
      this.userService.getUser().subscribe(data => {
        this.user = data;
        this.initAuthData();
      });
    } else {
      this.initAuthData();
    }

  }

  ngAfterViewInit(): void {
    if (this.authorityData && this.authorityData.signingUrl)
      this.signaturePad.fromDataUrl(this.authorityData.signingUrl);
  }

  initAuthData(): void {
    let retrievedAuthority = sessionStorage.getItem('authorityData');
    let signingDate;
    let signingURL = null;
    let person;
    let company;
    let dauer;

    person = this.user.firstname + " " + this.user.lastname;
    company = this.currentMultiUserPlatform?.company ?? "-";
    signingDate = this.user.town + ",den " + this.aktDate;
    if (retrievedAuthority != null) {
      let authority = JSON.parse(retrievedAuthority);
      if (authority.signingDate !== "")
        signingDate = authority.signingDate;
      if (authority.signingUrl !== "")
        signingURL = authority.signingUrl;
      if (authority.person !== "")
        person = authority.person;
      if(authority.company !== "")
        company = authority.company;
      if(authority.dauer !== "")
        dauer = authority.dauer;
    }
    this.authorityData = new AuthorityData(signingURL, signingDate, person, company,dauer,this.interest, this.properties);

  }

  get aktDate() {
    return formatDate(new Date(), 'dd.MM.yyyy', 'en');
  }

  setAuthority(interest) {
    let verifyPad = this.signaturePad.verifyPad("Bitte signieren Sie die Vollmacht");
    let authorityData = this.getAuthorityData(interest);
    if (!verifyPad) {
      sessionStorage.setItem("authorityData", JSON.stringify(authorityData));
      this.authoritySigned.emit();
    }
    else this.errorMsg = verifyPad;
  }

  getAuthorityData(interest){
    this.interest = interest;
    let signingDate = $("#signing-date-input").val();
    let person = $("#company-person").val();
    let company = $("#company").val();
    let dauer = $("#dauer").val();
    let signingURL = this.signaturePad.toDataUrl();
    let authorityData = new AuthorityData(signingURL, signingDate, person, company, dauer,  this.interest, this.properties);
    return authorityData;
  }
}
